var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEuro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2413_15894)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.125 20.75C11.1708 20.75 7.82083 18.1083 6.74167 14.5H10.125C10.4708 14.5 10.75 14.2208 10.75 13.875C10.75 13.5292 10.4708 13.25 10.125 13.25H6.475C6.41667 12.8417 6.375 12.425 6.375 12C6.375 11.575 6.41667 11.1583 6.475 10.75H12.625C12.9708 10.75 13.25 10.4708 13.25 10.125C13.25 9.77917 12.9708 9.5 12.625 9.5H6.74167C7.82083 5.89167 11.1708 3.25 15.125 3.25C15.4708 3.25 15.75 2.97083 15.75 2.625C15.75 2.27917 15.4708 2 15.125 2C10.475 2 6.55417 5.19167 5.44167 9.5H2.625C2.27917 9.5 2 9.77917 2 10.125C2 10.4708 2.27917 10.75 2.625 10.75H5.20417C5.15417 11.1583 5.125 11.575 5.125 12C5.125 12.425 5.15417 12.8417 5.20417 13.25H2.625C2.27917 13.25 2 13.5292 2 13.875C2 14.2208 2.27917 14.5 2.625 14.5H5.44167C6.55417 18.8083 10.475 22 15.125 22C15.4708 22 15.75 21.7208 15.75 21.375C15.75 21.0292 15.4708 20.75 15.125 20.75Z",
    fill: "#194142"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2413_15894"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.75,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEuro);
export default __webpack_public_path__ + "static/media/icon-euro.f38395ce93a62376ea93420f02dcded1.svg";
export { ForwardRef as ReactComponent };